import { ArrowDownIcon } from 'lucide-react'

export const NewReplyPill = ({ onClick }: { onClick: () => void }) => (
  <div className="pointer-events-none absolute inset-x-0 bottom-2 flex justify-center">
    <button
      type="button"
      onClick={onClick}
      className="pointer-events-auto flex cursor-pointer items-center gap-1.5 rounded-full bg-brand-deep px-3 py-1.5 text-xs font-medium text-white shadow-md transition-colors hover:bg-brand-deep/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-deep focus-visible:ring-offset-2"
    >
      <ArrowDownIcon className="h-3.5 w-3.5" />
      New reply
    </button>
  </div>
)
